import http from "../../http";

/** 新版营销中心（与旧 promotion 并存） */
const marketing = {
  selectPage(r) {
    return http.get("/gateway/api/sycompany/pc/companyMarketing/selectPage", r);
  },
  selectById(r) {
    return http.get("/gateway/api/sycompany/pc/companyMarketing/selectById", r);
  },
  save(r) {
    return http.payload("/gateway/api/sycompany/pc/companyMarketing/save", r);
  },
  delete(r) {
    return http.post("/gateway/api/sycompany/pc/companyMarketing/delete", r);
  },
  changeActive(r) {
    return http.post("/gateway/api/sycompany/pc/companyMarketing/changeActive", r);
  },
  selectUserPage(r) {
    return http.get("/gateway/api/sycompany/pc/companyMarketing/selectUserPage", r);
  },
  saveUser(r) {
    return http.payload("/gateway/api/sycompany/pc/companyMarketing/saveUser", r);
  },
  deleteUser(r) {
    return http.post("/gateway/api/sycompany/pc/companyMarketing/deleteUser", r);
  },
  trialCalc(r) {
    return http.payload("/gateway/api/sycompany/pc/companyMarketing/trialCalc", r);
  }
};

export default marketing;
